import React from 'react'
import classNames from 'classnames'

// Dải tab TỰ ĐỨNG (không dùng antd Tabs) - đồng nhất phong cách pill đã dùng xuyên suốt module Sổ
// Gia Đình (LookupScopeTabBar ở WorkspaceFamilyBook.js). DÙNG CHUNG cho FamilyBookDetail.js (trang
// cá nhân, own URL) và ParishBookReviewDrawer.js (drawer duyệt sổ giáo dân tự tạo, Workspace) - cả
// 2 đều cần tách Thông tin/Thành viên/Ghi chú thay vì 1 khối cuộn dài quá chật.
// tabs: [{key, label}].
const FamilyBookDetailTabBar = ({tabs, activeKey, onChange}) => (
    <div className="overflow-x-auto">
        <div className="p-1 bg-family-50 rounded-xl flex items-center gap-2 w-fit">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    type="button"
                    onClick={() => onChange(tab.key)}
                    className={classNames(
                        'px-3 py-1.5 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer',
                        activeKey === tab.key ? 'background text-family-700' : 'text-family-700 opacity-60',
                    )}>
                    {tab.label}
                </button>
            ))}
        </div>
    </div>
)

export default FamilyBookDetailTabBar
